import { handleOtherResponseCode, InviteClientAdmin, Login, REDIRECT, SUCCESS_REPONSE_CODE,
         toastr, UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE,
         useTranslation, CustomToastrAction} from '@/imports-files/pages/clients/invite-admin';


export async function createUserData(values, client_id, role_id){

  let hash                    = { client: { id: client_id }}
  let client_users_attributes = []

  values.map((value) =>
  {
    let client_user = { user_attributes: { email: value}, role_id: role_id }
    client_users_attributes.push(client_user)
  })

  return hash.push(client_users_attributes)
}

export async function inviteAdminFormSubmit(values, client_id, role_id, router){
  // ---------------------------- Initialization ------------------------------
  let body                      =   { client: { }}
  let client_users_attributes   =   []
  values.map((value) => {
                          let client_user = { user_attributes: { email: value}, role_id: role_id}
                          client_users_attributes.push(client_user)
                        })
  body["client"]["client_users_attributes"] = client_users_attributes
  body.invite_admin           = true
  const result                =   await new InviteClientAdmin().inviteAdmins(body, client_id);
  const status_code           =   result.status || result.response.status;
  const response              =   result.data || result.response.data
  const customToastrAction    =   new CustomToastrAction(); 
  // ---------------------------- Initialization ------------------------------
  switch (status_code) {
    case SUCCESS_REPONSE_CODE:
      if (response.success) {
        customToastrAction.setNormalToastr(response.success, 'success');
        // toastr.success(response.success)
        router.push(REDIRECT.client.activities)
      }
      break;
    case UNAUTHORIZED_REPONSE_CODE:
        customToastrAction.setNormalToastr(response.error, 'warning');
        // toastr.warning(response.error);
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        customToastrAction.setNormalToastr(result.response.data.error.client.base, 'warning');
        // toastr.warning(result.response.data.error.client.base);
        break;
      default:
      handleOtherResponseCode(status_code, router);
    }
}
